import React from "react";

const base = (props) => ({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
  ...props,
});

export const ArrowRight = (p) => (
  <svg {...base(p)}>
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);
export const ArrowLeft = (p) => (
  <svg {...base(p)}>
    <path d="M19 12H5M11 5l-7 7 7 7" />
  </svg>
);
export const ArrowUpRight = (p) => (
  <svg {...base(p)}>
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);
export const Check = (p) => (
  <svg {...base(p)}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
export const Close = (p) => (
  <svg {...base(p)}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);
export const Menu = (p) => (
  <svg {...base(p)}>
    <path d="M4 8h16M4 16h16" />
  </svg>
);
export const Camera = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="7" width="13" height="10" rx="2" />
    <path d="m16 11 5-2.5v7L16 13z" />
    <circle cx="9.5" cy="12" r="2" />
  </svg>
);
export const Cctv = (p) => (
  <svg {...base(p)}>
    <path d="m3.5 9.5 12-4.2a2 2 0 0 1 2.6 1.2l.9 2.6-14 4.9-1-2.5a1.6 1.6 0 0 1 .5-2z" />
    <path d="M7 14.5 6 19h3.5" />
    <path d="M19 8.5 21 8" />
    <path d="m14 13.5 1.5 3.5" />
  </svg>
);
export const Cpu = (p) => (
  <svg {...base(p)}>
    <rect x="6" y="6" width="12" height="12" rx="2" />
    <rect x="9.5" y="9.5" width="5" height="5" rx="1" />
    <path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" />
  </svg>
);
export const Cloud = (p) => (
  <svg {...base(p)}>
    <path d="M7.5 18.5a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 18.4 10a4.25 4.25 0 0 1-.9 8.5z" />
  </svg>
);
export const Layers = (p) => (
  <svg {...base(p)}>
    <path d="m12 3 9 5-9 5-9-5z" />
    <path d="m3 13 9 5 9-5" />
  </svg>
);
export const Shield = (p) => (
  <svg {...base(p)}>
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
export const City = (p) => (
  <svg {...base(p)}>
    <path d="M3 21h18" />
    <path d="M5 21V9h6v12" />
    <path d="M11 21V4h8v17" />
    <path d="M14 8h2M14 12h2M14 16h2M7 13h2M7 17h2" />
  </svg>
);
export const Heart = (p) => (
  <svg {...base(p)}>
    <path d="M12 21s-7-4.6-9-9.2A5 5 0 0 1 12 8a5 5 0 0 1 9 3.8C19 16.4 12 21 12 21z" />
    <path d="M7 12h2l1.5-2.5 2 5L14 12h3" />
  </svg>
);
export const Factory = (p) => (
  <svg {...base(p)}>
    <path d="M3 21V10l6 4v-4l6 4v-4l6 4v7z" />
    <path d="M3 21h18" />
    <path d="M7 21v-3M11 21v-3M15 21v-3" />
  </svg>
);
export const Eye = (p) => (
  <svg {...base(p)}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
export const Radar = (p) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="4" />
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
  </svg>
);
export const Zap = (p) => (
  <svg {...base(p)}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
  </svg>
);
export const Bell = (p) => (
  <svg {...base(p)}>
    <path d="M6 16v-5a6 6 0 0 1 12 0v5l2 2H4z" />
    <path d="M10 21h4" />
  </svg>
);
export const Scan = (p) => (
  <svg {...base(p)}>
    <path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2" />
    <rect x="8" y="8" width="8" height="8" rx="1" />
  </svg>
);
export const Sparkles = (p) => (
  <svg {...base(p)}>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
    <path d="M19 16l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" />
  </svg>
);
export const Search = (p) => (
  <svg {...base(p)}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);
export const Map = (p) => (
  <svg {...base(p)}>
    <path d="M4 6l5-2 6 2 5-2v14l-5 2-6-2-5 2z" />
    <path d="M9 4v14M15 6v14" />
  </svg>
);
export const Wrench = (p) => (
  <svg {...base(p)}>
    <path d="M3 21l6.5-6.5" />
    <path d="M14.5 3.5a5 5 0 0 0-5 6.7L3 16.7V21h4.3l6.5-6.5a5 5 0 0 0 6.7-5l-3 1-2.2-2.2 1-3z" />
  </svg>
);
export const Truck = (p) => (
  <svg {...base(p)}>
    <path d="M3 6h11v10H3z" />
    <path d="M14 10h4l3 3v3h-7z" />
    <circle cx="7" cy="18" r="2" />
    <circle cx="17" cy="18" r="2" />
  </svg>
);
export const Link = (p) => (
  <svg {...base(p)}>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </svg>
);
export const Grid = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);
export const Activity = (p) => (
  <svg {...base(p)}>
    <path d="M3 12h4l3-8 4 16 3-8h4" />
  </svg>
);
export const Server = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="4" width="18" height="6" rx="1.5" />
    <rect x="3" y="14" width="18" height="6" rx="1.5" />
    <path d="M7 7h.01M7 17h.01" />
  </svg>
);
export const Signal = (p) => (
  <svg {...base(p)}>
    <path d="M2 8.5a16 16 0 0 1 20 0M5 12a11 11 0 0 1 14 0M8.5 15.5a6 6 0 0 1 7 0" />
    <circle cx="12" cy="19" r="1" />
  </svg>
);
export const Lock = (p) => (
  <svg {...base(p)}>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);
export const Clock = (p) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);
export const Plug = (p) => (
  <svg {...base(p)}>
    <path d="M9 3v5M15 3v5" />
    <path d="M6 8h12v3a6 6 0 0 1-12 0z" />
    <path d="M12 17v4" />
  </svg>
);
export const Box = (p) => (
  <svg {...base(p)}>
    <rect x="4" y="4" width="16" height="16" rx="1" strokeDasharray="3 2.5" />
    <path d="M9 12h6M12 9v6" />
  </svg>
);
export const Mail = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);
export const Route = (p) => (
  <svg {...base(p)}>
    <circle cx="6" cy="19" r="2" />
    <circle cx="18" cy="5" r="2" />
    <path d="M8 19h6a3 3 0 0 0 0-6H10a3 3 0 0 1 0-6h6" />
  </svg>
);
export const Gauge = (p) => (
  <svg {...base(p)}>
    <path d="M4 18a9 9 0 1 1 16 0" />
    <path d="M12 13l4-4" />
    <circle cx="12" cy="13" r="1.5" />
  </svg>
);
export const LinkedIn = (p) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...p}
  >
    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4v15h-4zM8.5 8h3.8v2.05h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V23h-4v-7.7c0-1.84-.03-4.2-2.56-4.2-2.56 0-2.95 2-2.95 4.07V23h-4z" />
  </svg>
);
